
import { utils } from 'xlsx';
import * as XLSX from 'xlsx';

/**
 * Generates an Excel template for importing cycle data
 */
export const generateExcelTemplate = (): Blob => {
  const workbook = utils.book_new();
  
  const headers = [
    'Cycle Start Date', 
    'Cycle End Date', 
    'Symptoms Logged', 
    'Mood', 
    'Medications Taken', 
    'Contraceptive Use', 
    'Notes'
  ];
  
  const exampleData = [
    ['2024-03-01', '2024-03-06', 'Cramps, Fatigue', 'Low', 'Ibuprofen', 'Birth Control Pill', 'Felt very tired.'],
    ['2024-03-29', '2024-04-03', 'Headache, Acne', 'Medium', 'None', 'IUD', 'Minor discomfort.'],
    ['2024-04-27', '2024-05-02', 'Bloating, Irritability', 'High', 'Magnesium', 'None', 'Stressful day.']
  ];
  
  const data = [headers, ...exampleData];
  const worksheet = utils.aoa_to_sheet(data);
  
  utils.book_append_sheet(workbook, worksheet, 'Cycle Data Template');
  
  // Generate Excel file
  const excelData = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
  return new Blob([excelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
};
